export default "__VITE_ASSET__BHIzqCR$__"